import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneDeep, filter, mergeWith } from "lodash";
export const SET_REFERRERS = "SET_REFERRERS";
export const SET_FLOWS = "SET_FLOWS";
export const SET_CLIENTS = "SET_CLIENTS";
export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const SET_CONSENT_STATUS = "SET_CONSENT_STATUS";
export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";
export const SET_CONSENT_OBTAINED_DATE = "SET_CONSENT_OBTAINED_DATA";
export const REMOVE_APPLICATION = "REMOVE_APPLICATION";
export const SET_CLIENT_APPLICATIONS = "SET_CLIENT_APPLICATIONS";
export const MARK_VERIFICATION_FOR_IMPORT = "MARK_VERIFICATION_FOR_IMPORT";
export default {
  [SET_REFERRERS]: (state, data) => {
    state.referrers = data.referrers;
  },
  [SET_FLOWS]: (state, flows) => {
    state.flows = flows;
  },
  [SET_CLIENTS]: (state, {
    clients,
    total,
    add,
    agentUsername,
    applicationCount
  }) => {
    if (add) {
      state.clients.byId = _objectSpread(_objectSpread({}, state.clients.byId), clients.byId);
      state.clients.allIds.push(...clients.allIds);
    } else {
      state.clients.allIds = clients.allIds;
      _Object$entries(clients.byId).forEach(([username, client]) => {
        var _context, _state$clients$byId$u, _state$clients$byId$u2, _context2;
        client.applications = [...new _Set([...(client.fullyLoaded ? [] : _mapInstanceProperty(_context = (_state$clients$byId$u = (_state$clients$byId$u2 = state.clients.byId[username]) == null ? void 0 : _state$clients$byId$u2.applications) != null ? _state$clients$byId$u : []).call(_context, id => _parseInt(id))), ..._mapInstanceProperty(_context2 = client.applications).call(_context2, id => _parseInt(id))])];
      });
      state.clients.byId = clients.byId;
    }
    state.totalClients = total;
    state.currentAgent = agentUsername;
    state.applicationCount = applicationCount;
  },
  [SET_APPLICATIONS]: (state, {
    applications
  }) => {
    state.applications.byId = _objectSpread(_objectSpread({}, state.applications.byId), applications.byId);
  },
  [SET_CLIENT_APPLICATIONS]: (state, {
    clientUsername,
    applications,
    applicationsById
  }) => {
    state.clients.byId[clientUsername].applications = _mapInstanceProperty(applications).call(applications, app => app.applicationId);
    state.applications.byId = _objectSpread(_objectSpread({}, state.applications.byId), cloneDeep(applicationsById));
  },
  [SET_CONSENT_OBTAINED_DATE]: (state, {
    date,
    applicationId
  }) => {
    state.applications.byId[applicationId].consentObtainedDate = date;
  },
  [SET_CONSENT_STATUS]: (state, {
    status,
    applicationId
  }) => {
    state.applications.byId[applicationId].consentStatus = status;
  },
  [SET_CURRENT_FILTERS]: (state, {
    orderBy,
    orderType,
    searchString,
    board,
    read,
    status
  }) => {
    state.clientsTableFilters = mergeWith({}, state.clientsTableFilters, {
      orderBy,
      orderType,
      searchString
    }, (current, replacement) => replacement != null ? replacement : current);
    state.clientsTableFilters = mergeWith({}, state.clientsTableFilters, {
      board,
      read,
      status
    }, (current, replacement) => replacement === undefined ? current : replacement);
  },
  [REMOVE_APPLICATION]: (state, {
    clientUsername,
    applicationId
  }) => {
    delete state.applications.byId[applicationId];
    state.applications.byId = _objectSpread({}, state.applications.byId);
    const client = state.clients.byId[clientUsername];
    if (client) {
      client.applications = filter(client.applications, app => app !== applicationId);
    }
  },
  [MARK_VERIFICATION_FOR_IMPORT]: (state, {
    emailFromExpert,
    shouldVerify
  }) => {
    state.import.verificationEmail = emailFromExpert;
    state.import.shouldVerifyEmail = shouldVerify;
  }
};